var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transfer-child-wrap"},[_c('div',{staticClass:"transfer-child-head"},[_c('span',[_vm._v(_vm._s(("" + (_vm.tableSelectedKeys.length > 0 ? _vm.tableSelectedKeys.length + "/" : "") + (_vm.filteredItems.length || "0") + " 项")))]),_c('span',[_vm._v(_vm._s(_vm.transferDirection == "left" ? "点位" : "已选点位"))])]),_c('a-input-search',{staticClass:"transfer-table-input",attrs:{"placeholder":"请输入搜索内容"},on:{"change":_vm.onSearch}}),_c('a-table',{staticStyle:{"width":"374px"},attrs:{"rowKey":"id","size":"small","bordered":false,"columns":_vm.tableColumns,"data-source":_vm.filteredItems,"loading":_vm.tableLoading || _vm.waiting,"pagination":{ showLessItems: true, onChange: _vm.changePage },"row-selection":{
      fixed: true,
      columnWidth: 40,
      selectedRowKeys: _vm.currentSelectedRowKeys,
      onChange: _vm.onSelectChange,
      hideDefaultSelections: true,
      onSelect: function onSelect(record, selected) {
        record.checked = selected;
        _vm.updateTableSelectedKeys();
        _vm.updateCurrentPageSelectedRowKeys(_vm.currentPage);
      },
      onSelectAll: function onSelectAll(selected) {
        _vm.filteredItems.forEach(function (item) {
          item.checked = selected;
        });
        _vm.updateTableSelectedKeys();
        _vm.updateCurrentPageSelectedRowKeys(_vm.currentPage);
      }
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }